/* Endless Drops LATAM Data Registry | v1.1.0
 *
 * Compatible registry for:
 * - ed-latam-dataset.js
 * - ed-latam-engine.js
 * - LATAM Hub section
 *
 * Responsibilities:
 * - Register one dataset payload.
 * - Build fast market/country indexes.
 * - Expose safe read APIs.
 * - Preserve preloaded-dataset compatibility.
 */

(function (window) {
  'use strict';

  var ED = window.ED_LATAM = window.ED_LATAM || {};

  var state = {
    meta: {},
    countries: [],
    markets: [],
    products: [],
    marketById: Object.create(null),
    countryByCode: Object.create(null),
    marketsByCountry: Object.create(null)
  };

  function array(value) {
    return Array.isArray(value) ? value : [];
  }

  function string(value) {
    return value === null || value === undefined
      ? ''
      : String(value);
  }

  function rebuildIndexes() {
    state.marketById = Object.create(null);
    state.countryByCode = Object.create(null);
    state.marketsByCountry = Object.create(null);

    state.countries.forEach(function (country) {
      if (!country || !country.code) return;

      state.countryByCode[country.code] = country;

      if (!state.marketsByCountry[country.code]) {
        state.marketsByCountry[country.code] = [];
      }
    });

    state.markets.forEach(function (market) {
      if (!market || !market.id) return;

      state.marketById[market.id] = market;

      var countryCode = string(market.country_code);

      if (!state.marketsByCountry[countryCode]) {
        state.marketsByCountry[countryCode] = [];
      }

      state.marketsByCountry[countryCode].push(market);
    });

    Object.keys(state.marketsByCountry)
      .forEach(function (countryCode) {
        state.marketsByCountry[countryCode]
          .sort(function (a, b) {
            return string(a.name).localeCompare(
              string(b.name),
              'es',
              { sensitivity: 'base' }
            );
          });
      });
  }

  ED.registerData = function (payload) {
    payload = payload || {};

    state.meta = payload.meta || {};
    state.countries = array(payload.countries);
    state.markets = array(payload.markets);
    state.products = array(payload.products);

    rebuildIndexes();

    ED.ready = true;
    ED.dataVersion = state.meta.version || 'unknown';

    window.dispatchEvent(
      new CustomEvent('ed:latam-data-ready', {
        detail: {
          version: ED.dataVersion,
          market_count: state.markets.length,
          country_count: state.countries.length,
          monthly_record_count:
            state.meta.monthly_record_count || null
        }
      })
    );

    return {
      ok: true,
      version: ED.dataVersion,
      market_count: state.markets.length,
      country_count: state.countries.length
    };
  };

  ED.getMeta = function () {
    return state.meta;
  };

  ED.getCountries = function () {
    return state.countries.slice();
  };

  ED.getCountryByCode = function (countryCode) {
    return state.countryByCode[string(countryCode)] || null;
  };

  ED.getMarkets = function () {
    return state.markets.slice();
  };

  ED.getMarketsByCountry = function (countryCode) {
    var markets =
      state.marketsByCountry[string(countryCode)] || [];

    return markets.slice();
  };

  ED.getMarket = function (marketId) {
    return state.marketById[string(marketId)] || null;
  };

  ED.getProducts = function () {
    return state.products.slice();
  };

  ED.getProduct = function (manufacturer, model) {
    manufacturer = string(manufacturer).toLowerCase();
    model = string(model).toLowerCase();

    return state.products.find(function (product) {
      return (
        string(product && product.manufacturer).toLowerCase() === manufacturer &&
        string(product && product.model).toLowerCase() === model
      );
    }) || null;
  };

  ED.isReady = function () {
    return ED.ready === true;
  };

  ED.getDataQualitySummary = function () {
    var monthlyRecordCount = 0;
    var climateReadyMonths = 0;
    var missingClimateMonths = 0;

    state.markets.forEach(function (market) {
      array(market.months).forEach(function (month) {
        monthlyRecordCount++;

        var climate = string(month.climate).toUpperCase();
        var t = Number(month.t);
        var rh = Number(month.rh);

        var valid =
          Number.isFinite(t) &&
          Number.isFinite(rh) &&
          rh > 0 &&
          climate.indexOf('PENDING') === -1 &&
          climate.indexOf('MISSING') === -1;

        if (valid) {
          climateReadyMonths++;
        } else {
          missingClimateMonths++;
        }
      });
    });

    return {
      version: ED.dataVersion || 'unknown',
      market_count: state.markets.length,
      country_count: state.countries.length,
      monthly_record_count: monthlyRecordCount,
      climate_ready_months: climateReadyMonths,
      missing_climate_months: missingClimateMonths,
      climate_coverage_pct:
        monthlyRecordCount
          ? Math.round(
              climateReadyMonths /
              monthlyRecordCount *
              10000
            ) / 100
          : 0
    };
  };

  /*
   * Compatibility:
   * If dataset.js executed before this registry, consume the queued payload now.
   */
  if (window.ED_LATAM_DATASET) {
    ED.registerData(window.ED_LATAM_DATASET);

    try {
      delete window.ED_LATAM_DATASET;
    } catch (e) {}
  }

  window.dispatchEvent(
    new CustomEvent('ed:latam-data-layer-ready', {
      detail: { version: '1.1.0' }
    })
  );

})(window);
